import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  private _baseUrl: string = "";
  private _controllerName: string = "";

  constructor(private _http: HttpClient) {
    this._baseUrl = environment.apiUrl;
    this._controllerName = "Projects"
  }

  // private getHeaders(): HttpHeaders{
  //   return new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'Authorization': `Bearer ${this.getToken()}`
  //   })
  // }

  insert(payload: any): Observable<any> {
    return this._http.post<any>(`${this._baseUrl}/${this._controllerName}`, payload).pipe(catchError(this.handleErrors))
  }

  update(id: number, payload: any): Observable<any> {
    return this._http.put<any>(`${this._baseUrl}/${this._controllerName}/${id}`, payload).pipe(catchError(this.handleErrors))
  }

  delete(id: number): Observable<any> {
    return this._http.delete<any>(`${this._baseUrl}/${this._controllerName}/${id}`).pipe(catchError(this.handleErrors))
  }

  getAll(): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/`).pipe(catchError(this.handleErrors))
  }

  /**
   * Obtiene proyectos con paginación, búsqueda y filtros del lado servidor.
   */
  getProjectsPaged(parameters: any): Observable<any> {
    let params = new HttpParams();

    if (parameters.pageNumber !== undefined && parameters.pageNumber !== null) {
      params = params.append('pageNumber', parameters.pageNumber.toString());
    }
    if (parameters.pageSize !== undefined && parameters.pageSize !== null) {
      params = params.append('pageSize', parameters.pageSize.toString());
    }
    if (parameters.searchTerm) {
      params = params.append('searchTerm', parameters.searchTerm);
    }
    if (parameters.sortBy) {
      params = params.append('sortBy', parameters.sortBy);
    }
    if (parameters.sortOrder) {
      params = params.append('sortOrder', parameters.sortOrder);
    }
    if (parameters.status) {
      params = params.append('status', parameters.status);
    }
    if (parameters.typeProject !== undefined && parameters.typeProject !== null) {
      params = params.append('typeProject', parameters.typeProject.toString());
    }
    if (parameters.startDate) {
      params = params.append('startDate', parameters.startDate.toISOString());
    }
    if (parameters.endDate) {
      params = params.append('endDate', parameters.endDate.toISOString());
    }
    if (parameters.dateType) {
      params = params.append('dateType', parameters.dateType);
    }
    if (parameters.filterId !== undefined && parameters.filterId !== null) {
      params = params.append('filterId', parameters.filterId.toString());
    }

    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/paged`, { params })
      .pipe(catchError(this.handleErrors));
  }

  getAllFiltered(searchTerm?: string): Observable<any> {
    let params: any = {};
    if (searchTerm && searchTerm.trim() !== '') {
      params.searchTerm = searchTerm.trim();
    }

    const queryString = Object.keys(params).length > 0 ? '?' + Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&') : '';
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}${queryString}`).pipe(catchError(this.handleErrors))
  }

  /**
   * Lista mínima de proyectos para dropdowns (id + label + moneda + montos).
   * Reemplaza getAll() en formularios para evitar traer Budgets y grafos profundos.
   */
  getLookup(searchTerm?: string): Observable<any> {
    const params = searchTerm && searchTerm.trim() !== ''
      ? `?searchTerm=${encodeURIComponent(searchTerm.trim())}`
      : '';
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/lookup${params}`)
      .pipe(catchError(this.handleErrors));
  }

  getById(id: number): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/${id}`).pipe(catchError(this.handleErrors))
  }

  getWorkOrdersByProjectId(id: number): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/WorkOrdersByProject/${id}`).pipe(catchError(this.handleErrors))
  }

  getParticipantsByProjectId(id: number): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/Participants/${id}`).pipe(catchError(this.handleErrors))
  }

  getDetailedParticipantsByProjectId(id: number): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/DetailedParticipants/${id}`).pipe(catchError(this.handleErrors))
  }

  checkDuplicity(projectId: string): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/check-duplicity/${projectId}`).pipe(catchError(this.handleErrors))
  }

  getIncomeReceiptsByProjectId(id: number): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/IncomeReceipt/project/${id}`).pipe(catchError(this.handleErrors))
  }

  getExcessPaymentsByProjectId(id: number): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/ExcessPayments/project/${id}`).pipe(catchError(this.handleErrors))
  }

  getRefundVouchersByProjectId(id: number): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/RefundVouchers/project/${id}`).pipe(catchError(this.handleErrors))
  }

  getIncomeProjectBudgetsByProjectId(id: number): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/ProjectBudget/project/${id}/income`).pipe(catchError(this.handleErrors))
  }


  private handleErrors(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.log("Ocurrio un error", error.error.message);
    } else {
      console.log(`Ocurrio un error ${error.status}, ${error.error}`);
    }
    return throwError(() => new Error('Algo salió mal; por favor, intente nuevamente más tarde.'));
  }
}
